/* eslint-disable no-template-curly-in-string */
import store from "@/store";

export function ToggleLoader(show, transparent = false) {
    store.dispatch('LoaderAction', {
        show: show,
        transparent: transparent
    }).then(() => undefined)
}
